/* eslint-disable angular/factory-name */
angular.
module("digiexam.services").
factory("Broadcaster", function Broadcaster(
	$rootScope
) {
	"use strict";

	function broadcastItem() {
		$rootScope.$broadcast(this.event);
	}

	return {
		message: "",
		event: "",
		broadcast: function broadcast(e, msg) {
			this.message = msg;
			this.event = e;
			broadcastItem.call(this);
		},
	};
});
